import React, {FC, Fragment, useEffect, useRef, useState} from "react";
import Badge from "shared/Badge/Badge";
import {useParams, useSearchParams} from "react-router-dom";
import Input from "shared/Input/Input";
import {format} from "date-fns";

import ButtonPrimary from "shared/Button/ButtonPrimary";

import {
  BuyOrderType,
  CouponType,
  EventType,
  LocalitySelectedType,
  OrderType,
  PhaseType,
  ProductType,
  RaffleType,
  SeatType,
  UserType,
} from "data/types";
import {convertServerDateToLocalDate} from "utils/convertServerDateToLocalDate";
import {
  useBuyDiscountQueueTicketsMutation,
  useBuyQueueTicketsMutation,
  useDeleteSeatsByEventMutation,
  useExitBuyQueueTicketsMutation,
  useGetAdsByEventQuery,
  useGetEventQuery,
  useGetPhasesByEventMutation,
  useLazyGetRaffleQuery,
  useLazyVerifyCouponQuery,
  useSaveOrderMutation,
  useVerifyCouponLocalityMutation,
} from "store/api";
import NcInputNumberLocalities from "components/NcInputNumberLocalities/NcInputNumberLocalities";
import NcModal from "shared/NcModal/NcModal";
import {TimerProvider} from "contexts/TimerContext";
import {Helmet} from "react-helmet-async";
import visaPng from "images/vis.png";
// import mastercardPng from "images/mastercard.svg";
import {ReactComponent as MastercardIcon} from "images/mastercard.svg";
import amexPng from "images/amex.png";
import dinersPng from "images/diners.png";
import discoverPng from "images/discover.png";
import Billing from "components/Billing/Billing";
import {ProgressBar} from "components/Raffle/ProgressBar";
import {LuckyNumbers} from "components/Raffle/LuckyNumbers";
import {Combos} from "components/Raffle/Combos";
import {useAuth} from "contexts/AuthContext";
import {Loading} from "components/Loading/Loading";
import DetailPagetLayout from "./Layout";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import SectionSliderEvent from "components/SectionSliderEvent/SectionSliderEvent";
import {SuccessModal} from "components/SuccessModal/SuccessModal";

const EventPageContainer: FC<{event: EventType; influencer: string}> = ({
  event,
  influencer,
}) => {
  const eventDate = convertServerDateToLocalDate(event.startTime);
  const [phases, setPhases] = useState<PhaseType[]>([]);
  const [rowValues, setRowValues] = useState<Record<string, number>>({});
  const [subtotal0, setSubtotal0] = useState(0);
  const [subtotal15, setSubtotal15] = useState(0);
  const [vat, setVat] = useState(0);
  const [totalCommision, setTotalCommision] = useState(0);
  const [totalCommisionVat, setTotalCommisionVat] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [subtotalVat, setSubtotalVat] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [total, setTotal] = useState(0);
  const currentTime = new Date();
  const [cantTickets, setCantTickets] = useState(0);
  const timer = useRef<NodeJS.Timeout | null>(null);
  const [coupon, setCoupon] = useState("");
  const [couponMessageError, setCouponMessageError] = useState("");

  const [verifyCoupon] = useLazyVerifyCouponQuery();
  const [verifyCouponLocality] = useVerifyCouponLocalityMutation();

  const [localities, setLocalities] = useState<any[]>([]);
  const [verifyingCoupon, setVerifyingCoupon] = useState(false);
  const [haveProfile, setHaveProfile] = useState(false);
  const [havePhone, setHavePhone] = useState(false);
  const [localitiesSelected, setLocalitiesSelected] = useState<
    LocalitySelectedType[]
  >([]);
  const [errorList, setErrorList] = useState<any[]>([]);

  const [getRaffleData] = useLazyGetRaffleQuery();
  const [exitBuyQueueTickets] = useExitBuyQueueTicketsMutation();
  const [joinBuyQueueTickets] = useBuyQueueTicketsMutation();
  const [joinBuyDiscountQueueTickets] = useBuyDiscountQueueTicketsMutation();
  const [codeQueue, setCodeQueue] = useState<string>("");

  const {isLoggedIn} = useAuth();
  const [raffleData, setRaffleData] = useState<RaffleType | null>(null);
  const [validCoupon, setValidCoupon] = useState<CouponType | null>(null);
  const [codeDiscountQueue, setCodeDiscountQueue] = useState<string>("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [isPaying, setIsPaying] = useState(false);

  const [saveOrder] = useSaveOrderMutation();

  const [deleteSeatsSelectedByEvent] = useDeleteSeatsByEventMutation();
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);

  useEffect(() => {
    if (event.category === "Sorteo") {
      const getRaffle = async () => {
        const {data} = await getRaffleData(event._id);
        if (data) {
          const raffleData = data.data;
          const raffle: RaffleType = {
            available: raffleData.available,
            digits: raffleData.digits,
            luckyNumbers: raffleData.luckyNumbers,
            percentage: raffleData.percentage,
            total: raffleData.total,
            winnersNumbers: raffleData.winnersNumbers,
          };
          setRaffleData(raffle);
        }
      };
      getRaffle();
    }
  }, []);

  useEffect(() => {
    let newSubtotal0 = 0;
    let newSubtotal15 = 0;
    let newVat = 0;
    let newTotalCommision = 0;
    let newTotalCommisionVat = 0;
    let newTotal = 0;
    let newSubtotal = 0;
    if (event.iva) {
      newSubtotal15 = phases.reduce((acc, phase) => {
        const rowValue = rowValues[phase.description] || 0;
        return (
          acc +
          rowValue *
            (parseFloat(phase.priceWithVAT) / (1 + event.valueIva / 100))
        );
      }, 0);
      setSubtotal15(newSubtotal15);

      newSubtotal = phases.reduce((acc, phase) => {
        const rowValue = rowValues[phase.description] || 0;
        return acc + rowValue * +phase.priceWithVAT;
      }, 0);
      setSubtotalVat(newSubtotal);

      newVat = newSubtotal15 * (event.valueIva / 100);
      setVat(newSubtotal - newSubtotal15);

      newTotalCommision = phases.reduce((acc, phase) => {
        const rowValue = rowValues[phase.description] || 0;
        return (
          acc +
          rowValue *
            (parseFloat(phase.commisionIva) / (1 + event.valueIva / 100))
        );
      }, 0);
      setTotalCommision(newTotalCommision);
      newTotalCommisionVat = newTotalCommision * (event.valueIva / 100);
      setTotalCommisionVat(newTotalCommisionVat);

      const totalWithVat =
        newSubtotal15 + newVat + newTotalCommision + newTotalCommisionVat;
      setSubtotal(totalWithVat);

      newTotal = phases.reduce((acc, phase) => {
        const rowValue = rowValues[phase.description] || 0;
        return acc + rowValue * +phase.priceWithVAT;
      }, 0);
      setTotal(totalWithVat - discount);
    } else {
      newSubtotal0 = phases.reduce((acc, phase) => {
        const rowValue = rowValues[phase.description] || 0;
        return acc + rowValue * +phase.priceWithoutVAT;
      }, 0);
      setSubtotal0(newSubtotal0);

      newTotalCommision = phases.reduce((acc, phase) => {
        const rowValue = rowValues[phase.description] || 0;
        return acc + rowValue * +phase.commisionNoIva;
      }, 0);
      setTotalCommision(newTotalCommision);

      newTotalCommisionVat = newTotalCommision * (15 / 100);
      setTotalCommisionVat(newTotalCommisionVat);

      newSubtotal = phases.reduce((acc, phase) => {
        const rowValue = rowValues[phase.description] || 0;
        return acc + rowValue * +phase.priceWithVAT;
      }, 0);
      const subt = newSubtotal + newTotalCommision + newTotalCommisionVat;
      setSubtotal(subt);

      newTotal = phases.reduce((acc, phase) => {
        const rowValue = rowValues[phase.description] || 0;
        return acc + rowValue * +phase.priceWithVAT;
      }, 0);
      setTotal(subt - discount);
    }

    setCantTickets(
      phases.reduce((acc, phase) => {
        const rowValue = rowValues[phase.description] || 0;
        return acc + rowValue;
      }, 0),
    );
    if (cantTickets === 0) {
      setDiscount(0);
      setCoupon("");
    }
    // }, [rowValues, phases, event]);
  }, [rowValues, event, discount]);

  const handleRowChange = (value: number, phase: PhaseType) => {
    setDiscount(0);
    setRowValues((prev) => ({
      ...prev,
      [phase.description]: value,
    }));
    setLocalities((prev) => {
      const existingLocalityIndex = prev.findIndex(
        (loc) => loc[0] === phase.locality,
      );

      if (existingLocalityIndex >= 0) {
        prev[existingLocalityIndex][1] = value;
        prev[existingLocalityIndex][3] = +phase.priceWithVAT;
        return [...prev];
      } else {
        return [...prev, [phase.locality, value, false, +phase.priceWithVAT]];
      }
    });
  };

  const [getPhasesByEvent, {data}] = useGetPhasesByEventMutation();
  const [hasDataChanged, setHasDataChanged] = useState(false);

  const [paymentSelected, setPaymentSelected] = useState("");

  const {data: adsData} = useGetAdsByEventQuery(event._id);

  const [ads, setAds] = useState<string[]>([]);

  useEffect(() => {
    if (adsData) {
      adsData.list.map((item: any) => {
        return setAds((prevAds) => [...prevAds, item.advertising]);
      });
    }
  }, [adsData]);

  const changePayment = (payment: any) => {
    setPaymentSelected(payment.description);
  };

  useEffect(() => {
    getPhasesByEvent({event: event._id});
  }, [getPhasesByEvent]);

  useEffect(() => {
    if (data && !hasDataChanged) {
      const newPhases = data?.localities?.map((localities: any) => {
        console.log("localities:", localities);
        return localities.phases.map((phase: any) => ({
          _id: phase._id,
          status: phase.status,
          public: phase.public,
          position: phase.position,
          type: phase.type,
          name: phase.name,
          stock: phase.stock,
          typePublic: phase.typePublic,
          priceWithVAT: phase.priceWithVAT,
          priceWithoutVAT: phase.priceWithoutVAT,
          startDate: phase.startDate,
          endDate: phase.endDate,
          locality: phase.locality,
          log: phase.log,
          commisionIva: phase.commisionIva,
          commisionNoIva: phase.commisionNoIva,
          acronym: localities.acronym,
          description: localities.description,
          sequenceStart: phase.sequenceStart,
          typeNumbering: localities.typeNumbering,
          localityStock: localities.stock,
          listSubscriber: localities?.listSubscriber,
          haveSpecialDiscount: localities?.haveSpecialDiscount,
          haveSeatSelection: localities.isZone,
        }));
      });

      setPhases(newPhases?.flat());
      setLocalitiesSelected(
        newPhases?.map((phase: any) => ({
          _id: phase[0].locality,
          quantity: 0,
          haveDiscount: phase[0].description.includes("* Aplica condiciones"),
          description: phase[0].description,
          listSubscriber: phase[0].listSubscriber,
          zones: [],
          phase: phase[0]._id,
          acronym: phase[0].acronym,
          price: +phase[0].priceWithVAT,
          secuenceStart: phase[0].sequenceStart,
          endTime: phase[0].endDate,
          haveSeatSelection: phase[0].haveSeatSelection,
        })),
      );
      setHasDataChanged(true);
    }
  }, [data, hasDataChanged]);

  const userData = localStorage.getItem("user");
  let user: UserType;
  if (userData) {
    user = JSON.parse(userData) as UserType;
  }

  const handleDiscount = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      setCoupon(value);
      await verifyDiscount(value);
    }, 500);
  };

  const verifyDiscount = async (coupon: string) => {
    if (coupon === "") {
      setCouponMessageError("");
      setDiscount(0);
      return;
    }
    setValidCoupon(null);

    setVerifyingCoupon(true);
    const {data, error} = await verifyCoupon({
      code: coupon,
      customer: user._id,
      item: event._id,
      type: "events",
    });
    if (error) {
      console.log(error);
      const fetchError = error as {
        status: number;
        data: {error: string; statusMessage: string};
      };
      if (fetchError.status === 400) {
        if (fetchError.data.error === "Validar por localidad") {
          await verifyDiscountByLocality(coupon);
        } else {
          setDiscount(0);
          setCouponMessageError("Cupón inválido");
          setVerifyingCoupon(false);
        }
      }
    }
    if (data) {
      setCouponMessageError("");
      if (data.meta.status === 200) {
        const coupon: CouponType = {...data.coupon};

        if (coupon.typeDiscount === "PERCENTAGE") {
          event.iva
            ? setDiscount((subtotal15 + vat) * (coupon.valueDiscount / 100))
            : setDiscount((subtotal0 + vat) * (coupon.valueDiscount / 100));
          setValidCoupon(coupon);
        } else {
          setDiscount(+coupon.valueDiscount);
          setValidCoupon(coupon);
        }
        setVerifyingCoupon(false);
      }
    }
  };

  const verifyDiscountByLocality = async (code: string) => {
    setCouponMessageError("");
    const prices = localities.map((locality) => {
      return locality[1] * locality[3];
    });
    const {data, error} = await verifyCouponLocality({
      code,
      body: {localities, prices},
    });
    if (error) {
      console.log(error);
      const fetchError = error as {
        status: number;
        data: {error: string; statusMessage: string};
      };
      if (fetchError.status === 400) {
        setDiscount(0);
        setCouponMessageError("Cupón inválido");
        setVerifyingCoupon(false);
      }
    }
    if (data) {
      if (data.meta.status === 200) {
        const couponDiscount: CouponType = {
          _id: data.coupon._id,
          code: data.coupon.code,
          typeDiscount: data.coupon.typeDiscount,
          valueDiscount: data.coupon.valueDiscount,
          category: data.coupon.category,
        };

        const discounts = data.discounts;
        const discount = discounts.reduce((acc: any, discountLocal: any) => {
          return acc + discountLocal;
        }, 0);
        if (discount > 0) {
          setDiscount(discount);
          setValidCoupon(couponDiscount);
        } else {
          setCouponMessageError("Cupón inválido");
        }
        setVerifyingCoupon(false);
      }
    }
  };

  useEffect(() => {
    verifyDiscount(coupon);
  }, [total]);
  useEffect(() => {
    // console.log(localitiesSelected);
  }, [localitiesSelected]);

  const verifySeatsSelected = () => {
    let errorList: any = [];
    setErrorList([]);
    phases.forEach((phase) => {
      if (phase.typeNumbering === "Alfanumérico") {
        localitiesSelected.forEach((locality) => {
          if (locality._id === phase.locality) {
            let counterSeats = 0;
            locality.zones.forEach((zone) => {
              counterSeats += zone.seats.length;
            });
            if (counterSeats !== locality.quantity) {
              errorList.push(
                locality.quantity +
                  " asientos en la localidad " +
                  phase.description,
              );
            }
          }
        });
      }
    });
    setErrorList(errorList);
    setTimeout(() => setErrorList([]), 5000);
    return errorList;
  };

  const verifyStock = async () => {
    const {data} = await getPhasesByEvent({event: event._id});

    let result: string[] = [];

    if (data) {
      console.log("fjkslajfs", data);
      data.localities.forEach((locality: any) => {
        localitiesSelected.forEach((localitySelected: LocalitySelectedType) => {
          if (locality._id === localitySelected._id) {
            if (locality.stock < localitySelected.quantity) {
              const newPhases = data?.localities?.map((localities: any) => {
                return localities.phases.map((phase: any) => ({
                  _id: phase._id,
                  status: phase.status,
                  public: phase.public,
                  position: phase.position,
                  type: phase.type,
                  name: phase.name,
                  stock: phase.stock,
                  typePublic: phase.typePublic,
                  priceWithVAT: phase.priceWithVAT,
                  priceWithoutVAT: phase.priceWithoutVAT,
                  startDate: phase.startDate,
                  endDate: phase.endDate,
                  locality: phase.locality,
                  log: phase.log,
                  commisionIva: phase.commisionIva,
                  commisionNoIva: phase.commisionNoIva,
                  acronym: phase.acronym,
                  description: localities.description,
                  sequenceStart: phase.sequenceStart,
                  typeNumbering: localities.typeNumbering,
                  localityStock: localities.stock,
                  listSubscriber: localities.listSubscriber[0]?._id,
                }));
              });

              setPhases(newPhases?.flat());
              const errorMsg = `La localidad ${locality.description} solo tiene ${locality.stock} tickets disponibles`;

              // al set error list agregar el nuevo error
              setErrorList((prev) => [...prev, errorMsg]);
              setTimeout(() => setErrorList([]), 5000);
              result = [...result, errorMsg];
            }
          }
        });
      });
    }
    return result;
  };

  const exitQueue = async () => {
    await exitBuyQueueTickets({
      userId: user._id,
      eventId: event._id,
    });
  };

  const joinQueue = async () => {
    const bodyLocalities = localitiesSelected
      .filter((loc) => loc.quantity > 0)
      .map((loc) => ({
        _id: loc._id,
        quantity: loc.quantity,
        phase: loc.phase,
      }));
    const body = {
      event: event._id,
      localities: bodyLocalities,
      customer: user._id,
    };
    const {data: queueData, error} = await joinBuyQueueTickets(body);
    if (error) {
      console.log("error queue");
      console.log(error);
      return "";
    }
    if (queueData && queueData.meta.status === 200) {
      setCodeQueue(queueData.queue.code);
      return queueData.queue.code;
    }
  };

  const joinDiscountQueue = async () => {
    const body = {
      coupon: validCoupon?._id,
      quantity: 1,
      customer: user._id,
    };
    const {data: discountQueue} = await joinBuyDiscountQueueTickets(body);
    console.log("discountQueue");
    console.log(discountQueue);
    setCodeDiscountQueue(discountQueue.discountQueue.code);
  };

  const totalQuantity = event.hasCapacity
    ? localitiesSelected
        .filter((loc) => loc.quantity > 0)
        .reduce((sum, loc) => sum + loc.quantity, 0)
    : 0;

  const saveFreeOrder = async () => {
    setIsPaying(true);
    const now = new Date();
    const formattedDate = format(now, "yyyy/MM/dd-HH:mm:ss");

    const seatErrors = verifySeatsSelected(); // retorna array
    const stockErrors = await verifyStock(); // retorna array

    const allErrors = [...seatErrors, ...stockErrors];
    if (isLoggedIn && allErrors.length === 0) {
      await exitQueue();
      const code = await joinQueue();
      console.log("code");
      console.log(code);
      if (code) {
      }
      const order: OrderType = {
        codeDiscountQueue: codeDiscountQueue,
        vatTax: event.iva,
        category: event.category,
        event: event._id,
        codeQueue: code,
        quantity: totalQuantity,
        orderSubtotal: 0,
        orderComision: 0,
        orderComisionIva: 0,
        orderIva: 0,
        orderTotal: 0,
        statusBuy: false,
        platformBuy: "WEB_BEE",
        paymentType: "FREE",
        orderDiscount: 0,
        orderTotalPartial: 0,
        orderType: "NORMAL",
        invoiceUser: "",

        devReference: `Bee-Web ${
          JSON.parse(localStorage.getItem("user")!)?._id
        }-${formattedDate}`,
        authorizationCode: "",
        transactionId: "",
        endTime: event.endTime,
        ...(influencer !== "" && {
          influencer: influencer,
        }),
      };

      const products: ProductType[] = localitiesSelected
        .filter((locality) => locality.quantity > 0)
        .map((loc) => {
          const seats: SeatType[] = loc.haveSeatSelection
            ? loc.zones
                .filter((zone) => zone.seats.length > 0)
                .map((zone) => {
                  return zone.seats.map((seat, index) => {
                    return {
                      position: seat,
                      number: zone.numbers[index],
                      topic: zone._id,
                    };
                  });
                })
                .flat()
            : Array.from({length: loc.quantity}, () => ({
                position: "0_0",
                number: "0_0",
              }));

          return {
            locality: loc._id,
            localityName: loc.description,
            localityPrice: loc.price,
            secuenceStart: loc.secuenceStart,
            acronym: loc.acronym,
            endTime: loc.endTime,
            quantity: loc.quantity,
            acronymEvent: event.acronym,
            phase: loc.phase,
            haveSpecialDiscount: loc.haveDiscount,
            valueSpecialDiscount: loc.haveDiscount ? loc.price : 0,
            listSubscriber: loc.listSubscriber,
            seat: seats,
          };
        });
      const buyOrder: BuyOrderType = {
        order,
        products,
      };

      console.log(buyOrder);
      const {data: orderResponse} = await saveOrder(buyOrder);

      if (orderResponse && orderResponse.meta.status === 201) {
        setShowSuccessModal(true);
        setIsPaying(false);
      }
    } else {
      setIsPaying(false);
    }
  };

  const pay = async (openModal: Function) => {
    setIsLoadingPayment(true);
    const isSubscription = event.publicType === "Abonados";
    const userDataUpdated = localStorage.getItem("user");
    let userUpdated: UserType;

    if (!isLoggedIn) {
      setIsLoadingPayment(false);
      openModal();
      return;
    }

    if (userDataUpdated) {
      userUpdated = JSON.parse(userDataUpdated) as UserType;
      if (!userUpdated.ci || !userUpdated?.phone || !userUpdated?.username) {
        setIsLoadingPayment(false);

        openModal();
        return;
      }
    }
    setHaveProfile(true);
    setHavePhone(true);
    const seatErrors = verifySeatsSelected(); // retorna array
    const stockErrors = await verifyStock(); // retorna array

    const allErrors = [...seatErrors, ...stockErrors];
    if (isLoggedIn && allErrors.length === 0) {
      await exitQueue();
      const code = await joinQueue();
      if (code === "") {
        setIsLoadingPayment(false);
        setErrorList([
          "Los precios han cambiado, por favor actualiza la página",
        ]);
        setTimeout(() => setErrorList([]), 5000);

        return;
      }
      console.log(validCoupon);
      if (validCoupon) {
        await joinDiscountQueue();
      }
      setIsLoadingPayment(false);

      openModal();

      return;
    }
  };

  const removeSeatsSelected = async () => {
    await deleteSeatsSelectedByEvent(event._id);
  };

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap !space-y-6">
        <div className="flex justify-between items-center">
          <Badge name={event.category} color="yellow" />
          {/* <LikeSaveBtns /> */}
        </div>

        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold">
          {event.nameEvent}
        </h2>

        {/* 3 */}
        {event.category !== "Sorteo" && (
          <div className="flex items-center space-x-4">
            {/* <StartRating /> */}
            {/* <span>·</span> */}
            <span>
              <i className="las la-map-marker-alt"></i>
              <span className="ml-1">
                {event.city.description}, {event?.place}
              </span>
            </span>
          </div>
        )}

        {event.category !== "Sorteo" && (
          <div className="flex items-center space-x-4">
            <span>
              <i className="las la-calendar"></i>
              <span className="ml-1">{eventDate.customDate}</span>
            </span>
          </div>
        )}
        {event.category !== "Sorteo" && (
          <div className="flex items-center space-x-4">
            <span>
              <i className="las la-clock"></i>
              <span className="ml-1">{eventDate.customTime}</span>
            </span>
          </div>
        )}
      </div>
    );
  };

  const renderAbout = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Acerca del evento</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="text-neutral-6000 dark:text-neutral-300 whitespace-pre-line text-justify">
          <span>{event.description}</span>
          <br />
          <br />
        </div>
      </div>
    );
  };

  const renderRequirements = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Requisitos</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="text-neutral-6000 dark:text-neutral-300">
          <span>{event.requirementsDescription}</span>
          <br />
          <br />
        </div>
      </div>
    );
  };

  const renderConditions = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Condiciones</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="text-neutral-6000 dark:text-neutral-300">
          <span>
            * Al ingresar al evento se solicitará un documento de identificación
            para verificar las compras con descuentos(Tercera
            Edad/Niños/Personas con Discapacidad).
          </span>
          <br />
          <br />
        </div>
      </div>
    );
  };

  const renderSidebar = () => {
    return (
      <TimerProvider onTimeExpire={removeSeatsSelected}>
        <div className="listingSectionSidebar__wrap shadow-xl">
          <Helmet>
            <title>Bee || {event.nameEvent}</title>
          </Helmet>
          {event.isFree && (
            <div className="flex justify-between">
              <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
                ¡Gran noticia!
                <br />
                Este evento es totalmente gratuito.
                <br />
                Es una excelente oportunidad
                <br />
                para disfrutar de una experiencia
                <br />
                increíble sin costo alguno. 🌟✨
                <br />
                ¡No te lo pierdas,
                <br />
                te esperamos con mucho entusiasmo! 🥳🎈
              </span>
            </div>
          )}

          {event.category !== "Sorteo" &&
            phases?.length > 0 &&
            phases.map((phase: PhaseType, index) => (
              <NcInputNumberLocalities
                enablePurchase={currentTime > new Date(event.publicationTime)}
                startTime={event.publicationTime}
                localityId={phase.locality}
                haveDiscount={phase.description.includes(
                  "* Aplica condiciones",
                )}
                key={index}
                className="w-full"
                onChange={(value) => handleRowChange(value, phase)}
                maxQuantity={event.maximunTickets}
                currentQuantity={cantTickets}
                max={
                  phase.type === "DATE"
                    ? phase.localityStock
                    : phase.stock > phase.localityStock
                      ? phase.localityStock
                      : phase.stock
                }
                min={0}
                label={phase.description.split("*")[0]}
                desc={`$${phase.priceWithVAT} ${
                  phase.description.split("*")[1]
                    ? phase.description.split("*")[1] + "*"
                    : ""
                }`}
                phaseName={
                  phase.description.split("*")[0] === phase.name.split("*")[0]
                    ? ""
                    : phase.name
                }
                haveSelection={phase.typeNumbering === "Alfanumérico"}
                endTime={event.endTime}
                localitiesSelected={localitiesSelected}
                setLocalitiesSelected={setLocalitiesSelected}
                eventId={event._id}
                event={event}
                phase={phase}
                setErrorList={setErrorList}
              />
            ))}
          {!event.isFree && cantTickets > 0 && (
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200 animate-fadeIn">
                Tienes un cupón?
              </span>
              <Input
                className="mt-1 animate-fadeIn"
                placeholder="Ingresa tu cupón aquí"
                maxLength={10}
                onChange={handleDiscount}
              />
              {couponMessageError !== "" && (
                <p className="mt-2 text-red-500 text-xs">
                  {couponMessageError}
                </p>
              )}
            </label>
          )}

          {phases?.length > 0 && (
            <div className="listingSectionSidebar__wrap shadow-xl p-4 space-y-2 rounded-lg">
              <div className="flex justify-between">
                <span>Subtotal 0%:</span>
                <span>${subtotal0.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span>Subtotal 15%:</span>
                <span>${subtotal15.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span>IVA:</span>
                <span>${vat.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span>Fee Bee:</span>
                <span>${totalCommision.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span>Fee Bee IVA:</span>
                <span>${totalCommisionVat.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span>Subtotal:</span>
                <span>${subtotal.toFixed(2)}</span>
              </div>
              <div className="flex justify-between text-red-500">
                <span>Descuento:</span>
                <span>${discount.toFixed(2)}</span>
              </div>
              <div className="flex justify-between font-bold border-t pt-2 text-green-500">
                <span>Total:</span>
                <span>${total.toFixed(2)}</span>
              </div>
            </div>
          )}

          {!event.isFree && (
            <>
              <h3 className="text-xl font-semibold">Pagar con</h3>
              <div className="flex flex-col my-5 gap-2">
                {event.payments.map((payment: any, index) => (
                  <NcModal
                    renderTrigger={(openModal) => (
                      <ButtonSecondary
                        disabled={cantTickets <= 0}
                        loading={verifyingCoupon || isLoadingPayment}
                        key={index}
                        className={`w-full h-12 px-4 sm:px-6 rounded-full focus:outline-none flex items-center justify-center  
                          ${
                            cantTickets <= 0
                              ? "cursor-not-allowed"
                              : "cursor-pointer"
                          }
                          `}
                        onClick={() => {
                          changePayment(payment);
                          pay(openModal);
                        }}
                      >
                        <div className="flex items-center gap-2 h-full">
                          <span className="flex-shrink-0">
                            {payment.description === "Nuvei"
                              ? "Tarjeta"
                              : payment.description}
                          </span>

                          <div className="flex items-center gap-1">
                            <img
                              className="w-6 h-6 object-contain"
                              src={visaPng}
                              alt="visa"
                            />
                            <MastercardIcon className="w-6 h-6" />
                            {payment.description === "Nuvei" ? (
                              <img
                                className="w-4 h-4 object-contain"
                                src={amexPng}
                                alt="amex"
                              />
                            ) : (
                              <>
                                <img
                                  className="w-6 h-6 object-contain"
                                  src={dinersPng}
                                  alt="diners"
                                />
                                <img
                                  className="w-5 h-5 object-contain"
                                  src={discoverPng}
                                  alt="discover"
                                />
                              </>
                            )}
                          </div>
                        </div>
                      </ButtonSecondary>
                    )}
                    contentExtraClass={`w-full ${
                      isLoggedIn && haveProfile ? "sm:w-3/4" : "sm:w-1/2"
                    } `}
                    modalTitle={
                      isLoggedIn && haveProfile
                        ? "Completa la siguiente información"
                        : "Advertencia"
                    }
                    renderContent={() =>
                      isLoggedIn && !haveProfile ? (
                        <span className="block text-center text-neutral-700 dark:text-neutral-300">
                          Para proceder con la compra, debes {` `}
                          <a
                            href="/profile"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline"
                          >
                            completar tu perfil
                          </a>
                        </span>
                      ) : isLoggedIn && haveProfile ? (
                        <Billing
                          localitiesSelected={localitiesSelected}
                          setLocalitiesSelected={setLocalitiesSelected}
                          isSubscriber={event.publicType === "Abonados"}
                          paymentSelected={paymentSelected}
                          totalToPay={total}
                          eventName={event.nameEvent}
                          valueIva={event.valueIva}
                          haveIva={event.iva}
                          verifyStock={verifyStock}
                          codeDiscountQueue={codeDiscountQueue}
                          event={event}
                          codeQueue={codeQueue}
                          orderSubtotal={event.iva ? subtotal15 : subtotal0}
                          orderComision={totalCommision}
                          orderComisionIva={totalCommisionVat}
                          orderIva={vat}
                          orderTotal={total}
                          orderDiscount={discount}
                          influencer={influencer}
                        />
                      ) : (
                        <span className="block text-center text-neutral-700 dark:text-neutral-300">
                          Para proceder con la compra, {` `}
                          <a
                            href="/login"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline"
                          >
                            inicia sesión
                          </a>
                          . Si no tienes una cuenta, {` `}
                          <a
                            href="/signup"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline"
                          >
                            regístrate aquí
                          </a>
                          .
                        </span>
                      )
                    }
                  />
                ))}
              </div>
            </>
          )}

          {event.isFree && event.hasCapacity && (
            <ButtonPrimary
              disabled={cantTickets <= 0}
              loading={isPaying}
              onClick={() => saveFreeOrder()}
              className="w-full"
            >
              Adquirir tickets
            </ButtonPrimary>
          )}
          {errorList.length > 0 && (
            <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-3 rounded-2xl shadow-2xl transition-all duration-300 ease-in-out opacity-90 hover:opacity-100 hover:scale-105 flex flex-col gap-2">
              <span>Debes seleccionar:</span>
              {errorList.map((error: string, index) => (
                <div key={index}>{error}</div> // Cada error en una nueva línea
              ))}
            </div>
          )}
          <NcModal
            isOpenProp={showSuccessModal}
            modalTitle="Compra exitosa"
            contentExtraClass="max-w-md"
            triggerText=""
            renderContent={() => <SuccessModal />}
          />
        </div>
      </TimerProvider>
    );
  };

  return (
    <div className="nc-ListingStayDetailPage">
      {/*  HEADER */}
      <header className="mt-3 rounded-md sm:rounded-xl">
        <div
          className={`relative grid grid-cols-3 sm:grid-cols-3 gap-1 sm:gap-2 ${
            event.category === "Sorteo" ? "md:place-items-center" : ""
          } `}
        >
          <div
            className={`relative rounded-md sm:rounded-xl overflow-hidden
            ${
              event.category === "Sorteo"
                ? "col-span-3 row-span-1 sm:h-[70vh] sm:w-[70vw] h-[25vh]"
                : "col-span-2 row-span-3 sm:row-span-2 h-auto"
            }`}
          >
            {ads.length > 0 ? (
              <SectionSliderEvent
                className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                imgs={[event.img, ...ads]}
                uniqueClassName="EventSlider"
              />
            ) : (
              <img
                className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                src={event.img}
                alt=""
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
              />
            )}

            {/* <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div> */}
          </div>
          {event.category !== "Sorteo" && (
            <div className="relative rounded-md sm:rounded-xl overflow-hidden">
              <div className="aspect-w-4 aspect-h-2 sm:aspect-h-2 ring-1 ring-black/10 rounded-xl z-0 relative">
                <iframe
                  title="Mapa"
                  className="absolute inset-0 w-full h-full"
                  loading="lazy"
                  allowFullScreen
                  src={`https://www.google.com/maps?q=${event.lat},${event.lng}&hl=es&z=15&output=embed`}
                ></iframe>
                {event.secretLocation && (
                  <div className="absolute inset-0 bg-white/50 backdrop-blur-md flex items-center justify-center z-10">
                    <span className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-semibold text-gray-800">
                      Ubicación secreta
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
          {event.category !== "Sorteo" && (
            <div
              className={`relative rounded-md sm:rounded-xl overflow-hidden`}
            >
              <div className="aspect-w-4 aspect-h-2 sm:aspect-h-2 ring-1 ring-black/10 rounded-xl z-0">
                <div className="rounded-xl overflow-hidden z-0">
                  <img
                    className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                    src={
                      event.haveDistribution
                        ? `data:image/png;base64,${event.imgDistributionPlace}`
                        : "https://api.bee.com.ec/view/banner/67361e0df3d3dcd6f05644de.png"
                    }
                    alt=""
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
                  />
                  {/* <div className="absolute inset-0 bg-black/50 backdrop-blur-2xl flex items-center justify-center z-10">
                  <span className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-semibold text-primary-500">
                    {event.nameEvent}
                  </span>
                </div> */}
                </div>
              </div>
            </div>
          )}
        </div>
        {event.category === "Sorteo" && raffleData && (
          <>
            {raffleData.luckyNumbers.length > 0 && (
              <ProgressBar
                percentage={
                  +raffleData.percentage > 5.02 ? +raffleData.percentage : 5.02
                }
              />
            )}
            {raffleData.luckyNumbers.length > 0 && (
              <LuckyNumbers
                luckyNumbers={raffleData.luckyNumbers}
                winnersNumbers={raffleData.winnersNumbers}
              />
            )}
            {phases?.length > 0 && (
              <Combos
                enablePurchase={currentTime > new Date(event.publicationTime)}
                startTime={event.publicationTime}
                eventId={event._id}
                localityId={phases[0].locality}
                haveDiscount={phases[0].description.includes(
                  "* Aplica condiciones",
                )}
                onChange={(value) => handleRowChange(value, phases[0])}
                maxQuantity={event.maximunTickets}
                currentQuantity={cantTickets}
                max={
                  phases[0].stock > phases[0].localityStock
                    ? phases[0].localityStock
                    : phases[0].stock
                }
                haveSelection={phases[0].typeNumbering === "Alfanumérico"}
                endTime={event.endTime}
                localitiesSelected={localitiesSelected}
                setLocalitiesSelected={setLocalitiesSelected}
              />
            )}
          </>
        )}
      </header>
      {/* MAIN */}
      <main className=" relative z-10 mt-11 flex flex-col lg:flex-row mb-12">
        {/* CONTENT */}
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">
          {renderSection1()}
          {renderAbout()}
          {event.existRequirements && renderRequirements()}
          {event.category !== "Sorteo" && renderConditions()}
        </div>

        {/* SIDEBAR */}
        {/* remove hidden to show sidebar in mobile */}
        <div className="lg:block flex-grow mt-14 lg:mt-0">
          {/* <div className="hidden lg:block flex-grow mt-14 lg:mt-0"> */}
          <div className="sticky top-28">{renderSidebar()}</div>
        </div>
      </main>
    </div>
  );
};

export default function EventDetailPage() {
  const {id} = useParams();
  const [searchParams] = useSearchParams();

  const influencer = searchParams.get("influencer");
  console.log(influencer);
  const [event, setEvent] = useState<EventType | null>(null);
  let dataEvent = JSON.parse(atob(id!));
  const {data} = useGetEventQuery(dataEvent.event);
  useEffect(() => {
    if (data) {
      const item = data.eventDB;
      const eventSelected: EventType = {
        _id: item._id,
        nameEvent: item.nameEvent,
        date: item.date,
        category: item.category,
        city: {
          _id: item.city._id,
          description: item.city.description,
          province: item.city.province,
        },
        acronym: item.acronym,
        description: item.description,
        payments: item.payments,
        sponsors: item.sponsors,
        existRequirements: item.existRequirements,
        requirementsDescription: item.requirementsDescription,
        place: item.place,
        available: item.available,
        publicType: item.publicType,
        startTime: item.startTime,
        endTime: item.endTime,
        isFree: item.isFree,
        isDelete: item.isDelete,
        img: item.img,
        lat: item.lat,
        lng: item.lng,
        secretLocation: item.secretLocation,
        iva: item.iva,
        hasCapacity: item.hasCapacity,
        maximunTickets: item.maximunTickets,
        valueIva: item.valueIva,
        imgHeader: item.imgHeader,
        haveSubscribers: item.haveSubscribers,
        haveDistribution: item.haveDistribution,
        type: item.type,
        publicationDate: item.publicationDate,
        publicationTime: item.publicationTime,
        specialDiscounts: item.specialDiscounts,
        percentageSpecialDiscounts: item.percentageSpecialDiscounts,
        imgDistributionPlace: item.imgDistributionPlace,
        localitiesFrom: item.localitiesFrom,
        salesman: item.salesman,
      };

      setEvent(eventSelected);
    }
  }, [data]);
  return !event ? (
    <Loading />
  ) : (
    <DetailPagetLayout event={event}>
      {event.available === "FINALIZADO" || event.type === "Private" ? (
        <div className="h-[70vh] flex justify-center items-center">
          <h3>Evento no disponible</h3>
        </div>
      ) : (
        <EventPageContainer event={event} influencer={influencer ?? ""} />
      )}
    </DetailPagetLayout>
  );
}
